import { map, uniq, capitalize, pick } from 'lodash'
import moment from 'moment';
import rand from '../../helpers/rand'; 
import ImageURL from '../../helpers/ImageURL';
import icons from '../../helpers/Icons';
import { colors } from '../../components/widgets/charts/ChartDefaults';

export const mailingListsFormatter = {
    formatMailingLists,
    formatMailingList,
    formatMailingListRecipients,
    formatMailingListsByRecipient,
    formatCalendar,
    formatNewCatalogMailingList,
    formatCatalogMailingLists,
    formatCatalogMailingList
};

function formatMailingLists(data, filters){
    return data.data;
}

function formatMailingList(data){    
    return data.data;
}

function formatMailingListRecipients(data){
    if(!data)
        return [];
    let options = [];
    for(let item of data.data) {
        options.push({
            label: item.email, 
            value: item.email,
            ...item
        });
    }
    return options;
}

function formatMailingListsByRecipient(data) {
    return data.data;
}

function formatCalendar(calendar) {
    let value;
    switch(calendar.period) {
        case 'daily':
        case 'monthly_day':
            value = calendar.dayOfMonth;
            break;
        case 'weekly':
        case 'bi_weekly':
            value = calendar.dayOfWeek;
            break;
            
        case 'monthly_day_of_week':
            value = `${calendar.dayOfWeek}_${calendar.weekOfMonth}`;
            break;
    }
    return value;
}

function formatNewCatalogMailingList(payload, formattedParams) {
    const permittedFields = ["schedule_type", "schedule_value", "start_date", "end_date","enabled", "fields", "entity_type", "filter_id", "user_filter_id", "date_range"];
    let result = pick(payload, permittedFields);
    result.entity_type = payload.baseEntity;
    result.date_range = payload.duration;
    result.enabled = true;
    result.ei_payload = formattedParams;
    return result;
    
}

function formatCatalogMailingLists(data, filters){
    return data.data;
}

function formatCatalogMailingList({data}){
    console.log(data);
    const permittedFields = ["schedule_type", "schedule_value", "start_date", "end_date", "enabled", "fields", "user_filter_id", "filter_id"];
    let result = pick(data, permittedFields);
    result.baseEntity = data.entity_type;
    result.duration = data.date_range;
    return result;
}
